import { SimulationDetailsItemInterface } from '../../../../interfaces/request/simulator/simulation-details-item/simulation-details-item-interface';

export class SimulationDetailsItemModel implements SimulationDetailsItemInterface {
  proId?: number = -1;
  footNotes?: string = '';
  headNotes?: string = '';
  option?: string = '';
  list?: string[][] = [[]];
  productName?: string = '';
  currency? = 'EUR';
  totalAnnual?: number = -1;
  totalCommercialAnnual?: number = -1;
  totalCommercialMonthly?: number = -1;
  totalCommercialQuarterly?: number = -1;
  totalCommercialSemiannual?: number = -1;
  totalMonthly?: number = -1;
  totalQuarterly?: number = -1;
  totalSemiannual?: number = -1;
  uwSubscribe?: boolean = false;
  vsProId?: number = -1;
  productType?: string = '';
  additionalProduct?: {
    productType?: string;
    productName?: string;
    totalAnnual?: number;
    totalAnnualDiscount?: number;
    totalCommercialAnnual?: number;
    totalCommercialMonthly?: number;
    totalCommercialQuarterly?: number;
    totalCommercialSemiannual?: number;
    totalMonthly?: number;
    totalMonthlyDiscount?: number;
    totalQuarterly?: number;
    totalQuarterlyDiscount?: number;
    totalSemiannual?: number;
    totalSemiannualDiscount?: number;
    footNotes?: string;
    headNotes?: string;
  };
}
